import type { BackgroundMode } from "@shared/types/foyer";

/**
 * Which home-background layers to paint for a given `content.background.mode`.
 * Each scheme keeps its own photo + scrim JSX; this just gates them so the
 * operator's choice (solid colour / photo / photo+tint) is honoured. Absent mode
 * = legacy behaviour (photo + tint). `color` paints no photo → the scheme's own
 * surface shows through.
 *
 * Shared by the photo-forward launcher templates (Aurelia / Marea / Nord /
 * Terra / Tann) and the older bespoke schemes (Atelier / Mosaic / Spectrum).
 */
export function homeBgLayers(mode?: BackgroundMode): {
  photo: boolean;
  tint: boolean;
} {
  if (mode === "color") return { photo: false, tint: false };
  if (mode === "photo") return { photo: true, tint: false };
  return { photo: true, tint: true };
}
